var map = {
	"./decidim/avatar-multiuser.png": 7863,
	"./decidim/brands/google.svg": 4414,
	"./decidim/cc-badge.png": 2765,
	"./decidim/decidim-logo.svg": 5029,
	"./decidim/default-avatar.svg": 4693,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 9563,
	"./decidim/icons.svg": 1748,
	"./decidim/pattern.png": 1303,
	"./decidim/placeholder-card-g.svg": 3916,
	"./decidim/placeholder-card-l.svg": 5527,
	"./decidim/placeholder.jpg": 78,
	"./decidim/remixicon.symbol.svg": 4580,
	"./decidim/vendor/leaflet/layers-2x.png": 1565,
	"./decidim/vendor/leaflet/layers.png": 5828,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 7813,
	"./decidim/vendor/leaflet/marker-icon.png": 2380,
	"./decidim/vendor/leaflet/marker-shadow.png": 9395,
	"./decidim/vendor/social-share-button/douban.svg": 9031,
	"./decidim/vendor/social-share-button/email.svg": 2048,
	"./decidim/vendor/social-share-button/facebook.svg": 876,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 2408,
	"./decidim/vendor/social-share-button/hacker_news.svg": 5172,
	"./decidim/vendor/social-share-button/linkedin.svg": 7814,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 1727,
	"./decidim/vendor/social-share-button/pinterest.svg": 1598,
	"./decidim/vendor/social-share-button/reddit.svg": 4452,
	"./decidim/vendor/social-share-button/telegram.svg": 8297,
	"./decidim/vendor/social-share-button/tumblr.svg": 70,
	"./decidim/vendor/social-share-button/twitter.svg": 9325,
	"./decidim/vendor/social-share-button/vkontakte.svg": 3231,
	"./decidim/vendor/social-share-button/wechat.svg": 2778,
	"./decidim/vendor/social-share-button/whatsapp.svg": 3786,
	"./decidim/vendor/social-share-button/x.svg": 9872,
	"./decidim/vendor/social-share-button/xing.svg": 6776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5798;